export default {"src":"/_next/static/media/consul-logo-mark_on-light.5d3c4bdc.svg","height":72,"width":56,"blurWidth":0,"blurHeight":0};